/* dateTime */
/*--------------------------------------------------------------------------------*/
export const TH_MONTH: string[] = [
    'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
    'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม',
];
export const TH_MONTH_SHORT: string[] = [
    'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
    'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.',
];
export const FY_MONTH: string[] = [
    'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม', 'มกราคม', 'กุมภาพันธ์', 'มีนาคม',
    'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน',
];
export const FY_MONTH_SHORT: string[] = [
    'ต.ค.', 'พ.ย.', 'ธ.ค.', 'ม.ค.', 'ก.พ.', 'มี.ค.',
    'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.',
];
export const PERIOD_TEXT: string[] = ['', 'เวรดึก', 'เวรเช้า', 'เวรบ่าย'];
// time unix now
export const curTime = (): number => new Date().getTime();
/*--------------------------------------------------------------------------------*/
export const curDate = (): string => {
    return new Intl.DateTimeFormat('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(new Date());
};
/*--------------------------------------------------------------------------------*/
export const curMonth = (): string => {
    return new Intl.DateTimeFormat('en-CA', {
        year: 'numeric',
        month: '2-digit',
    }).format(new Date());
};
/*--------------------------------------------------------------------------------*/
export const curYear = (type: 'calendar' | 'fiscal' = 'calendar'): number => {
    const dt = new Date();
    const year = dt.getFullYear();
    const month = dt.getMonth() + 1;
    if (type === 'fiscal' && month >= 10) {
        return year + 1;
    }
    return year;
};
/*--------------------------------------------------------------------------------*/
type TimeFormat = 'date' | 'time' | 'full';
export const timeToStr = (unixtime: number, format: TimeFormat = 'full'): string => {
    if (!unixtime || typeof unixtime !== 'number') return '';
    const pad = (n: number) => n.toString().padStart(2, '0');
    const ms = unixtime < 10000000000 ? unixtime * 1000 : unixtime;
    const dt = new Date(ms);
    const yy = dt.getFullYear();
    const mm = pad(dt.getMonth() + 1);
    const dd = pad(dt.getDate());
    const h = pad(dt.getHours());
    const m = pad(dt.getMinutes());
    const s = pad(dt.getSeconds());
    const dateStr = `${yy}-${mm}-${dd}`;
    const timeStr = `${h}:${m}:${s}`;
    switch (format) {
        case 'date': return dateStr;
        case 'time': return timeStr;
        default: return `${dateStr} ${timeStr}`;
    }
};
/*--------------------------------------------------------------------------------*/
interface ShiftResult {
    num: 0 | 1 | 2 | 3;
    text: typeof PERIOD_TEXT[number];
}
export const curShift = (unixtime: number = 0): ShiftResult => {
    const ms = unixtime > 0
        ? (unixtime < 10000000000 ? unixtime * 1000 : unixtime)
        : Date.now();
    let num: ShiftResult['num'] = 0;
    const hour = new Date(ms).getHours();
    if (hour >= 0 && hour < 8) num = 1;
    else if (hour >= 8 && hour < 16) num = 2;
    else if (hour >= 16 && hour < 24) num = 3;
    return {
        num,
        text: PERIOD_TEXT[num]
    };
};
/*--------------------------------------------------------------------------------*/
export const setYear = (
    elm: HTMLSelectElement,
    min: number = 2020,
    label: string = ''
): void => {
    const dt = new Date();
    let maxYear = dt.getFullYear();
    if (dt.getMonth() + 1 > 6) {
        maxYear++;
    }
    elm.innerHTML = '<option value="">- เลือก -</option>';
    const fragment = document.createDocumentFragment();
    for (let y = min; y <= maxYear; y++) {
        const option = document.createElement('option');
        option.value = y.toString();
        option.text = `${label} ${y + 543}`.trim();
        fragment.appendChild(option);
    }
    elm.appendChild(fragment);
};
/*--------------------------------------------------------------------------------*/
export const thaiDate = (date: number | string, format = 0): string => {
    if (typeof date == 'string' && date.includes('0000-00-00')) {
        return '';
    }
    if (typeof date == 'string') {
        date = date.trim();
        date = date.replace(' ', 'T');
    }

    const dt = new Date(date);
    if (isNaN(dt.getTime())) return '';

    const yy = dt.getFullYear() + 543;
    const mm = String(dt.getMonth() + 1).padStart(2, '0');
    const dd = String(dt.getDate()).padStart(2, '0');
    const H = String(dt.getHours()).padStart(2, '0');
    const M = String(dt.getMinutes()).padStart(2, '0');
    const S = String(dt.getSeconds()).padStart(2, '0');

    // 01/01/2500
    if (format == 0) return `${dd}/${mm}/${yy}`;
    // 01/01/2500 00:00
    if (format == 1) return `${dd}/${mm}/${yy} ${H}:${M}`;
    // 01/01/2500 00:00:00
    if (format == 2) return `${dd}/${mm}/${yy} ${H}:${M}:${S}`;

    // 01 มกราคม 2500
    if (format == 10) return `${dd} ${TH_MONTH[Number(mm) - 1]} ${yy}`;
    // 01 ม.ค. 65
    if (format == 11) return `${dd} ${TH_MONTH_SHORT[Number(mm) - 1]} ${String(yy).slice(-2)}`;
    // 01 มกราคม 2500 เวลา 00:00 น.
    if (format == 12) return `${dd} ${TH_MONTH[Number(mm) - 1]} ${yy} เวลา ${H}:${M} น.`;
    // 01 ม.ค. 65 00:00
    if (format == 13) return `${dd} ${TH_MONTH_SHORT[Number(mm) - 1]} ${String(yy).slice(-2)} ${H}:${M}`;

    // มกราคม 2500
    if (format == 20) return `${TH_MONTH[Number(mm) - 1]} ${yy}`;
    // ม.ค. 2500
    if (format == 21) return `${TH_MONTH_SHORT[Number(mm) - 1]} ${yy}`;
    // ม.ค. 65
    if (format == 22) return `${TH_MONTH_SHORT[Number(mm) - 1]} ${String(yy).slice(-2)}`;

    return '';
};
/*--------------------------------------------------------------------------------*/
export const dateDiff = (start: string, stop: string): number => {
    const isValid = (d: string) => d && !d.includes('0000-00-00');
    if (!isValid(start) || !isValid(stop)) return 0;
    const d1 = new Date(start);
    const d2 = new Date(stop);
    if (isNaN(d1.getTime()) || isNaN(d2.getTime())) return 0;
    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);
    const diffTime = d2.getTime() - d1.getTime();
    return Math.round(diffTime / (1000 * 60 * 60 * 24));
};
/*--------------------------------------------------------------------------------*/
interface TimeDiffResult {
    h: number;
    m: number;
    s: number;
    total: number;
}
export const timeDiff = (start: string, stop: string): TimeDiffResult => {
    const isInvalid = (d: string) => !d || d.includes('0000-00-00');
    if (isInvalid(start) || isInvalid(stop)) {
        return { h: 0, m: 0, s: 0, total: 0 };
    }
    const d1 = new Date(start.replace(' ', 'T')).getTime();
    const d2 = new Date(stop.replace(' ', 'T')).getTime();
    if (isNaN(d1) || isNaN(d2)) {
        return { h: 0, m: 0, s: 0, total: 0 };
    }
    const msec = d2 - d1;
    //if (msec < 0) msec = 0; // ป้องกันเวลาติดลบ
    const totalSeconds = Math.floor(msec / 1000);
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    return { h, m, s, total: totalSeconds };
};
/*--------------------------------------------------------------------------------*/
export const getAge = (date: string, baseDate?: string) => {
    if (!date || date.includes('0000-00-00')) {
        return { years: 0, months: 0, days: 0 };
    }
    const now = baseDate ? new Date(baseDate) : new Date();
    const nowYear = now.getFullYear();
    const nowMonth = now.getMonth();
    const nowDate = now.getDate();

    const [yy, mm, dd] = date.split('-');
    const birth = new Date(Number(yy), Number(mm) - 1, Number(dd));
    const birthYear = birth.getFullYear();
    const birthMonth = birth.getMonth();
    const birthDate = birth.getDate();

    let yearAge = nowYear - birthYear;
    let monthAge: number;
    let dateAge: number;

    if (nowMonth >= birthMonth) {
        monthAge = nowMonth - birthMonth;
    } else {
        yearAge--;
        monthAge = 12 + nowMonth - birthMonth;
    }

    if (nowDate >= birthDate) {
        dateAge = nowDate - birthDate;
    } else {
        monthAge--;
        dateAge = 31 + nowDate - birthDate;
        if (monthAge < 0) {
            monthAge = 11;
            yearAge--;
        }
    }

    return {
        years: yearAge,
        months: monthAge,
        days: dateAge,
    };
};
/*--------------------------------------------------------------------------------*/
export const getAgeText = (date: string, baseDate?: string): string => {
    const { years, months, days } = getAge(date, baseDate);
    const parts = [];
    if (years > 0) parts.push(`${years} ปี`);
    if (months > 0) parts.push(`${months} เดือน`);
    if (days > 0) parts.push(`${days} วัน`);
    return parts.length > 0 ? parts.join(' ') : 'แรกเกิด';
};
/*--------------------------------------------------------------------------------*/
export const ageToBirth = (year: number, month: number, day: number): string => {
    const now = new Date();
    const dt = new Date(
        now.getFullYear() - Number(year),
        now.getMonth() - Number(month),
        now.getDate() - Number(day),
        0, 0, 0, 0
    );
    const yy = dt.getFullYear();
    const mm = String(dt.getMonth() + 1).padStart(2, '0');
    const dd = String(dt.getDate()).padStart(2, '0');
    return `${yy}-${mm}-${dd}`;
};
/*--------------------------------------------------------------------------------*/
export const toDbDate = (date: string): string => {
    if (!date || date.includes('0000-00-00')) return '';
    const dt = new Date(date);
    const yy = dt.getFullYear() - 543;
    const mm = String(dt.getMonth() + 1).padStart(2, '0');
    const dd = String(dt.getDate()).padStart(2, '0');
    return `${yy}-${mm}-${dd}`;
};
/*--------------------------------------------------------------------------------*/
export const toThaiDate = (date: string): string => {
    if (!date || date.includes('0000-00-00')) return '';
    const dt = new Date(date);
    const yy = dt.getFullYear() + 543;
    const mm = String(dt.getMonth() + 1).padStart(2, '0');
    const dd = String(dt.getDate()).padStart(2, '0');
    return `${yy}-${mm}-${dd}`;
};
/*--------------------------------------------------------------------------------*/
export const isToday = (date: string): boolean => {
    if (!date || date.includes('0000-00-00')) return false;
    const input = new Date(date);
    const today = new Date();
    if (isNaN(input.getTime())) return false;
    return (
        input.getFullYear() === today.getFullYear() &&
        input.getMonth() === today.getMonth() &&
        input.getDate() === today.getDate()
    );
};
/*--------------------------------------------------------------------------------*/
